var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogotypeClear(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1402.45 257.6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #F7FBEC;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M388.77,54.08h36.57v25.5c7.68-17.82,25.5-30.11,46.71-30.11s38.41,12.91,43.94,32.88c7.68-19.36,26.12-32.88,47.94-32.88,27.65,0,47.01,19.67,47.01,49.16v31.96c0,28.88.31,47.63,1.54,73.44h-38.41c.92-25.2,1.54-44.56,1.54-73.44v-28.58c0-19.05-9.83-30.73-26.12-30.73-18.13,0-31.34,16.59-31.34,39.64v19.67c0,28.88.61,47.63,1.84,73.44h-38.72c1.23-23.35,1.54-43.33,1.54-74.67v-27.35c0-18.74-10.14-30.73-26.12-30.73-17.82,0-31.03,16.59-31.03,39.64v19.67c0,28.88.31,47.63,1.54,73.44h-38.41"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M775.96,130.59v-4.3c0-29.19-.31-50.7-1.54-72.21h36.26v27.65c7.68-19.36,25.81-32.26,48.24-32.26,28.58,0,48.24,20.28,48.24,52.24v28.88c0,30.42.31,51.62,1.84,73.44h-38.72c1.23-21.51,1.84-43.02,1.84-73.44v-27.04c0-19.97-10.75-32.27-27.65-32.27-19.36,0-33.19,16.59-33.19,41.48v17.82c0,30.42.31,51.93,1.54,73.44h-38.41c1.23-21.51,1.54-43.02,1.54-73.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M970.1,194.2c17.82,0,29.5-10.45,29.5-25.5,0-11.68-6.76-17.82-19.36-22.43l-14.44-5.22c-26.73-9.83-37.49-24.58-37.49-43.94,0-29.19,24.58-47.63,59.31-47.63,11.37,0,23.35,2.15,34.41,5.53v18.42c-14.12-7.95-24.89-9.51-36.87-9.51-16.59,0-27.96,8.91-27.96,22.43,0,10.14,7.07,16.59,21.82,22.12l14.44,5.22c24.28,8.91,34.11,21.51,34.11,42.4,0,31.65-23.66,52.54-60.54,52.54-13.83,0-29.5-3.38-41.79-10.14v-26.12c14.75,14.44,29.81,21.82,44.86,21.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1064.89,164.7v-95.56l-29.5.31v-15.36l29.81.31V10.76l33.8-10.76v54.39l38.41-.31v15.36l-37.79-.31v95.87c0,14.75,6.76,22.74,18.44,22.74,6.76,0,13.52-2.46,19.36-7.07v13.21c-6.45,8.3-18.13,13.21-30.73,13.21-26.73,0-41.79-15.67-41.79-42.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1286.13,204.03h-36.26v-27.66c-7.68,19.36-25.81,32.27-48.55,32.27-28.27,0-47.94-20.28-47.94-51.93v-29.19c0-30.42-.31-57.46-1.84-73.44h36.87v100.17c0,20.28,10.76,32.57,27.96,32.57,19.36,0,33.19-16.59,33.19-41.48v-17.82c0-30.42-.61-51.93-1.84-73.44h36.87v77.74c0,29.19.31,50.7,1.54,72.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1313.03,130.29v-3.99c0-29.19-.31-50.7-1.54-72.21h35.95v39.33c5.53-25.81,21.51-41.48,43.63-41.48,6.76,0,11.37,1.54,11.37,1.54v32.57c-7.99-3.99-15.06-5.84-21.51-5.84-19.67,0-32.57,15.98-32.57,45.78v10.76c0,25.5.31,47.01,1.54,67.29h-38.41c1.23-21.51,1.54-43.02,1.54-73.75Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "8.99 204.09 0 204.09 55.07 54.09 64.05 54.09 8.99 204.09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "134.06 204.09 83.97 204.09 139.03 54.09 189.13 54.09 134.06 204.09"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 64.05,
    y: 54.09,
    width: 19.91,
    height: 150
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 189.13,
    y: 54.09,
    width: 99.82,
    height: 150
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M660.53,257.6h21.76l79.17-203.52h-22.78l-39.72,108.47-6.89-17.82c-13.83-36.26-23.05-61.15-33.19-90.65h-42.1l64.68,155.73-20.93,47.79Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogotypeClear);
export default __webpack_public_path__ + "static/media/logotype-clear.8e9484008ab50ccecf2ccb7248562991.svg";
export { ForwardRef as ReactComponent };